const siteTabs = new Map<string, string>([
  ['overview', 'Overview'],
  ['monitoring', 'Monitoring Setup'],
  ['timeline', 'Timeline'],
  ['assets', 'Assets'],
  ['edge-collectors', 'Edge Collectors'],
  ['incidents', 'Incidents'],
  ['history', 'History'],
  ['configuration', 'Configuration'],
  ['maintenance', 'Maintenance'],
]);

const monitoringTabs = new Map<string, string>([
  ['overview', 'Overview'],
  ['site-edge', 'Site Edge'],
  ['add-devices', 'Add Devices'],
  ['log-sources', 'Log Sources'],
  ['facilities', 'Facilities'],
  ['discovered-assets', 'Discovered Assets'],
  ['setup-status', 'Setup Status'],
]);

const monitoringTypes = new Map<string, string>([
  ['network-device', 'network'],
  ['server', 'server'],
  ['virtualization', 'virtualization'],
  ['storage', 'storage'],
  ['ups-pdu', 'ups'],
  ['facilities', 'facilities'],
  ['logs-events', 'logs'],
  ['website-api', 'web'],
  ['cloud-service', 'cloud'],
  ['other', 'other'],
]);

function keyForValue(values: Map<string, string>, value: string, fallback: string) {
  return [...values.entries()].find(([, candidate]) => candidate === value)?.[0] ?? fallback;
}

export type MonitoringSetupState = {
  tab: string;
  category: string;
};

export function readSiteDetailTab(search: string) {
  return siteTabs.get(new URLSearchParams(search).get('tab') ?? '') ?? 'Overview';
}

export function writeSiteDetailState(search: string, tab: string) {
  const params = new URLSearchParams(search);
  params.set('tab', keyForValue(siteTabs, tab, 'overview'));
  if (tab !== 'Monitoring Setup') {
    params.delete('workflow');
    params.delete('type');
  }
  return params.toString();
}

export function readMonitoringSetupState(search: string): MonitoringSetupState {
  const params = new URLSearchParams(search);
  const tab = monitoringTabs.get(params.get('workflow') ?? '') ?? 'Overview';
  const category =
    tab === 'Add Devices' ? (monitoringTypes.get(params.get('type') ?? '') ?? '') : '';
  return { tab, category };
}

export function writeMonitoringSetupState(search: string, state: MonitoringSetupState) {
  const params = new URLSearchParams(search);
  params.set('tab', 'monitoring');
  params.set('workflow', keyForValue(monitoringTabs, state.tab, 'overview'));
  if (state.tab === 'Add Devices' && state.category) {
    params.set('type', keyForValue(monitoringTypes, state.category, state.category));
  } else {
    params.delete('type');
  }
  return params.toString();
}

export function isSameDetailSelection(
  currentId: string | undefined,
  refreshedId: string | undefined,
) {
  return Boolean(currentId && refreshedId && currentId === refreshedId);
}
